import script from "./RacingFixtureBookOdd.vue?vue&type=script&setup=true&lang=js"
export * from "./RacingFixtureBookOdd.vue?vue&type=script&setup=true&lang=js"

import "./RacingFixtureBookOdd.vue?vue&type=style&index=0&id=c4fc6f96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4fc6f96"]])

export default __exports__